import { render, staticRenderFns } from "./zhongQiu.vue?vue&type=template&id=4f422c32&scoped=true&"
import script from "./zhongQiu.vue?vue&type=script&lang=js&"
export * from "./zhongQiu.vue?vue&type=script&lang=js&"
import style0 from "./zhongQiu.vue?vue&type=style&index=0&id=4f422c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f422c32",
  null
  
)

export default component.exports